import {type FC, type ReactNode, useMemo, useState} from 'react';

import { AlertContext } from './AlertContext';
import AlertComponent, { AlertType } from '../../components/alert/AlertComponent';


const ALERT_TIMEOUT = 6000;


interface AlertProviderProps {
    children: ReactNode;
}


export const AlertProvider: FC<AlertProviderProps> = ({ children }) => {
    const [text, setText] = useState<string | undefined>(undefined);
    const [type, setType] = useState<AlertType | undefined>(undefined);

    const setAlert = (type: AlertType | undefined, text: string | undefined) => {
        setType(type);
        setText(text);

        const timer = setTimeout(() => {
            setType(undefined);
            setText(undefined);
        }, ALERT_TIMEOUT);

        return () => clearTimeout(timer);
    };

    const contextValue = useMemo(() => ({
        text,
        type,
        setAlert
    }), [text, type]);

    return (
        <AlertContext.Provider value={contextValue}>
            <AlertComponent />
            {children}
        </AlertContext.Provider>
    );
};
